export default __webpack_public_path__ + "static/media/fatigue_logo.f3760680.jpeg";